<template>
  <md-list class="full-control">
    <md-list-item md-expand md-expanded>
      <span class="section-text">Detalles</span>
      <i></i>
      <md-list class="md-list-child" slot="md-expand">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-80"
            :class="!!relatedSinisters.length ? 'md-size-80' : 'md-size-100'"
          >
            <div class="md-layout mt-4">
              <f-field label="Fecha de orden" :value="order.addDate" :size="25"></f-field>
              <f-field label="Fecha de entrega" :value="order.deliveryDate" :size="25"></f-field>
              <f-field label="Condiciones de entrega" :value="order.sendConditions" :size="25"></f-field>
              <f-field label="Condiciones de pago" :value="order.paymentConditions" :size="25"></f-field>
              <f-field v-if="order.campName" label="Campamento" :value="order.campName" :size="25"></f-field>
              <f-field
                v-if="order.campAddress"
                label="Dirección"
                :value="order.campAddress"
                :size="25"
              ></f-field>
            </div>

            <div class="md-layout mt-4">
              <f-field label="Número de proveedor" :value="order.providerNumber" :size="25" />
              <f-field label="Proveedor" :value="order.providerName" :size="25" />
              <f-field label="Teléfono del proveedor" :value="order.providerPhone" :size="25" />
              <f-field label="Email del proveedor" :value="order.providerEmail" :size="25" />
            </div>
            <div class="md-layout mt-4">
              <f-field label="Solicitante" :value="order.resident" :size="25" />
              <f-field label="Teléfono del solicitante" :value="order.residentPhone" :size="25" />
              <f-field label="Celular del solicitante" :value="order.residentCellphone" :size="25" />
              <f-field label="Email del solicitante" :value="order.residentEmail" :size="25" />
            </div>
          </div>
          <div v-if="!!relatedSinisters.length" class="md-layout-item md-size-20">
            <md-list class="md-triple-line">
              <md-subheader>
                <h6>
                  <strong>Siniestros</strong>
                </h6>
              </md-subheader>
              <md-content class="md-scrollbar">
                <md-list-item v-for="(sinister, i) in relatedSinisters" :key="i">
                  <div class="md-list-item-text">
                    <div style="display: flex">
                      <button
                        class="btn-link"
                        @click="goToFile(sinister)"
                      >{{ sinister.sinisterNumber }}</button>
                    </div>

                    <p>
                      <span>Req:</span>
                      <strong>{{ sinister.requisitionNumber }}</strong>
                    </p>

                    <p>
                      <span>Folio:</span>
                      <strong>{{ sinister.folio }}</strong>
                    </p>
                  </div>
                </md-list-item>
              </md-content>
            </md-list>
          </div>
        </div>
      </md-list>
    </md-list-item>
    <md-list-item
      v-if="$can('view', 'PurchaseRequisition', 'advances') && advances.invoices.length"
      md-expand
      md-expanded
    >
      <span class="section-text">Facturas a OC</span>
      <i></i>
      <md-list class="md-list-child" slot="md-expand">
        <invoiceManager :value="advances.invoices" @deleteInvoice="deleteInvoice" />
      </md-list>
    </md-list-item>

    <md-list-item v-if="$can('add', 'PurchaseRequisition', 'advances')" md-expand md-expanded>
      <span class="section-text">Anticipos</span>
      <i></i>
      <md-list class="md-list-child" slot="md-expand">
        <slot name="advances"></slot>
      </md-list>
    </md-list-item>
  </md-list>
</template>

<script>
// COMPONENTS
import FField from "../Quotations/FField";
import invoiceManager from "./invoiceManager";

// SERVICES
import { fetchOrderRelatedSinisters } from "@/services/purchase/purchaseOrder";
import { deleteInvoiceToPurchaseOrder } from "@/services/purchase/purchaseOrder";

export default {
  name: "OrderDetails",
  components: { FField, invoiceManager },
  props: {
    order: {
      type: Object,
      required: true,
    },
    advances: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      relatedSinisters: [],
    };
  },

  methods: {
    goToFile({ sinisterId }) {
      let routeData = this.$router.resolve({
        name: "Ficha de Siniestro Carretero",
        params: { id: sinisterId },
      });
      window.open(routeData.href, "_blank");
    },
    deleteInvoice(invoice, index) {
      this.$confirmMessage({ title: "Borrar factura" }, () => {
        return deleteInvoiceToPurchaseOrder(this.order, invoice)
          .then(() => {
            this.$successMessage({ title: "Factura eliminada" });
            this.advances.invoices.splice(index, 1);
          })
          .catch(this.$fireErrorResponse);
      });
    },
    fetchRelatedSinisters() {
      const { order } = this;
      return fetchOrderRelatedSinisters(order).then((sinisters) => {
        this.relatedSinisters = sinisters;
      });
    },
  },

  watch: {
    source: {
      immediate: true,
      handler: "fetchRelatedSinisters",
    },
  },
};
</script>

<style lang="scss" scoped>
.md-scrollbar {
  width: 100%;
  max-height: 300px;
  overflow-y: scroll;
  scroll-behavior: smooth;
}
.md-button.sin-button .md-ripple {
  padding-left: 0px !important;
}
.full-control {
  padding: 0;
  .md-list-item {
    padding: 0;
    .md-list-child {
      padding: 0;
    }
    .md-list-item-container {
      background: rgb(240, 240, 240);
    }
    .section-text {
      margin: 8px 4px;
      font-size: 20px;
      font-weight: 600;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Purchases/PurchaseOrderTracking/OrderDetails.vue